export default "__VITE_ASSET__510f8dd5__"